module.exports = __webpack_public_path__ + "img/br3cj.54bdb963.png";